import { message as $message } from 'antd'
import {
    SESSION_KEY_REFERRER_IS_SUPPLIER,
    SESSION_KEY_REFERRER_IS_FINDCOOPERATIVE,
    LOCATION_KEY_DLZ_INVITEDID,
    LOCATION_KEY_PARTNER_INVITEDID,
} from './constant'
import { addQueryToUrl } from '@/utils/url'
import { FIND_COOPERATION_ROUTES } from '@/layouts/hooks/useSetCooperationOrigin'
import pathRegexp from 'path-to-regexp'
import { getLocalTerminalDomain } from '@/utils/jump'
import { getToken } from '@/utils/token'
import { getLoginCode } from '@/services/login'
import moment from 'moment'
import { saveOpenPromotionUrlInfo } from '@/services/partnership'

// 判断目前是否从供应侧过来
export const getDlzIsFromSupply = () => {
    if (window.MASTER_IS_SUPPLIER) {
        return true
    }
    if (window.TERMINANAME_IS_DLZ) {
        return !!sessionStorage.getItem(SESSION_KEY_REFERRER_IS_SUPPLIER)
    }
}

export const setDlzIsFromSupply = () => {
    return sessionStorage.setItem(SESSION_KEY_REFERRER_IS_SUPPLIER, 1)
}

// 品牌小站存储invitedId
export const getDlzInviteId = () => {
    return localStorage.getItem(LOCATION_KEY_DLZ_INVITEDID)
}
export const setDlzInviteId = value => {
    return localStorage.setItem(LOCATION_KEY_DLZ_INVITEDID, value)
}
export const removeDlzInviteId = () => {
    return localStorage.removeItem(LOCATION_KEY_DLZ_INVITEDID)
}

/**
 * 判断目前是否从寻合作过来 用于 getApplySourceV2AndModalType
 * @returns
 */

export const dlzIsFromFindCooperativeSession = {
    get: () => !!sessionStorage.getItem(SESSION_KEY_REFERRER_IS_FINDCOOPERATIVE),
    set: () => sessionStorage.setItem(SESSION_KEY_REFERRER_IS_FINDCOOPERATIVE, 1),
    clear: () => sessionStorage.removeItem(SESSION_KEY_REFERRER_IS_FINDCOOPERATIVE),
}

export const jumpSiteDomFn = (siteDomain: string) => {
    let url = `${siteDomain.indexOf('http') !== -1 ? siteDomain : `https://${siteDomain}`}`

    try {
        if (getDlzIsFromSupply()) {
            url = addQueryToUrl(url, {
                useSupplierRole: 1,
            })
        }

        // 从主站点进入的 添加标识
        url = addQueryToUrl(url, {
            fromMainDomain: 1,
        })

        window.open(url, '_blank')
    } catch (error) {
        console.error('catchError', error)
        window.open(url, '_blank')
    }
}

// 未分类改成其他商品。只有品牌小站要改
export const modListText = (list: any[]) => {
    const temp = (list || []).find(v => v.categoryName === '全部')
        ? []
        : [
              {
                  categoryName: '全部',
                  id: undefined,
                  isParent: 'N',
                  children: [],
              },
          ]
    for (let i = 0; i < list.length; i++) {
        const element = list[i]

        temp.push({
            ...element,
            categoryName: String(element.id) === '-1' ? '其他商品' : element.categoryName,
        })
    }
    return temp
}

export const onDlzGoChannelOrSupplier = async params => {
    const { pathname, isOpen } = params || {}
    if (!pathname) {
        return
    }

    const currentDomain = getDlzIsFromSupply()
        ? window.PROJECT_CONFIG.supplierTerminalName
        : window.PROJECT_CONFIG.channelTerminalName
    const url = `${getLocalTerminalDomain(currentDomain)}${pathname}`

    if (!getToken()) {
        window.open(url)
        return
    }
    try {
        const { success, data, message } = await getLoginCode()
        if (success) {
            const newUrl = encodeURIComponent(url)

            const route = `${getLocalTerminalDomain(
                window.PROJECT_CONFIG.accountTerminalName,
            )}/jumpPage/index?simple_token=${data}&redirect=${newUrl}`

            if (isOpen) {
                window.open(route)
                return
            }
            location.href = route
        } else {
            $message.error(message)
        }
    } catch (error) {
        console.error('catchError', error)
    }
}

// 未登录状态下, 保存合伙人推广链接的信息
export const setPartnerInviteId = (supplierCoId: string, inviteId: string) => {
    if (!supplierCoId) {
        return
    }
    try {
        const inviteCell = {
            [`${supplierCoId}`]: {
                inviteId,
                time: moment().format('YYYY-MM-DD HH:mm:ss'),
            },
        }

        const partnerInvite = JSON.parse(localStorage.getItem(LOCATION_KEY_PARTNER_INVITEDID) ?? '{}')

        localStorage.setItem(LOCATION_KEY_PARTNER_INVITEDID, JSON.stringify({ ...partnerInvite, ...inviteCell }))
    } catch (e) {
        console.error('catchError', e)
    }
}

// 邀约有效时间 - 线上
const INVITE_VALID_TIME_PROD = 3
const DIFF_UNIT_PROD = 'days'
// 邀约有效时间 - 其他环境
const INVITE_VALID_TIME_OTHER = 5
const DIFF_UNIT_OTHER = 'minute'
// 保存分享链接 - 登录后
export const savePartnerInviteUrl = async (inviteId: string, inviteType?: 'PARTNER') => {
    let diffUnit: 'days' | 'minute' = DIFF_UNIT_PROD
    let validTime = INVITE_VALID_TIME_PROD
    if (window.PROJECT_CONFIG.mode !== 'prod') {
        diffUnit = DIFF_UNIT_OTHER
        validTime = INVITE_VALID_TIME_OTHER
    }
    try {
        const currentTime = moment()
        // 获取保存在浏览器的推广信息
        const partnerInvite = JSON.parse(localStorage.getItem(LOCATION_KEY_PARTNER_INVITEDID) ?? '{}')
        // 三天内有效的推广信息
        let inviteIds =
            Object.keys(partnerInvite)
                ?.filter(key => {
                    const time = moment(partnerInvite[key].time)
                    return currentTime.diff(time, diffUnit) < validTime
                })
                ?.map(key => partnerInvite?.[key]?.inviteId) ?? []
        if (inviteType === 'PARTNER') {
            inviteIds = [...new Set([...inviteIds, inviteId])]
        }
        if (inviteIds.length === 0) {
            return
        }
        await saveOpenPromotionUrlInfo({ inviteIds })
    } catch (e) {
        console.error('catchError', e)
    }
}

// 获取当前合伙人 inviteId
export const getPartnerInviteId = supplierCoId => {
    let diffUnit: 'days' | 'minute' = DIFF_UNIT_PROD
    let validTime = INVITE_VALID_TIME_PROD

    const partnerInvite = JSON.parse(localStorage.getItem(LOCATION_KEY_PARTNER_INVITEDID) ?? '{}')
    const partnerData = partnerInvite?.[supplierCoId]
    const currentTime = moment()

    if (partnerData) {
        const time = moment(partnerData.time)
        if (currentTime.diff(time, diffUnit) < validTime) {
            return partnerData.inviteId
        }
    }

    return undefined
}
